var _rect, _rect2, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUiuxCard91(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 388,
    height: 189,
    viewBox: "0 0 388 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 387.5,
    height: 188.5,
    rx: 15.75,
    fill: "url(#paint0_linear_7226_7211)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 387.5,
    height: 188.5,
    rx: 15.75,
    stroke: "#74453F",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M259.418 1.5C274.406 1.5 285.404 7.25642 292.666 16.3994C299.94 25.5576 303.5 38.1586 303.5 51.8838C303.5 76.4831 295.758 94.1688 282.989 106.061C271.859 116.147 256.394 121.564 238.189 122.293H238.18L238.17 122.294C233.887 122.626 229.28 122.495 226.199 122.319V101.908C229.602 102.195 232.504 102.039 237.659 101.859H237.674C246.24 101.314 254.872 98.9408 261.131 94.5117L261.132 94.5127C269.024 89.1538 274.174 81.2396 276.2 72.208L276.282 71.8379L275.949 71.6582L275.598 71.4688L275.265 71.2881L275.001 71.5605C269.849 76.8846 262.211 79.9433 251.61 79.9434C241.755 79.9434 232.73 76.5294 226.172 70.2861C219.618 64.0467 215.5 54.9546 215.5 43.5391C215.5 20.7373 233.749 1.50013 259.418 1.5ZM258.31 20.6865C248.686 20.7156 241.869 29.4059 241.869 41.915C241.869 47.0945 243.298 51.9411 246.172 55.5039C249.056 59.0797 253.369 61.3251 259.04 61.3252C266.819 61.3252 272.231 57.8062 274.869 53.4443L274.879 53.4287L274.888 53.4121C275.856 51.4981 276.211 49.5937 276.212 46.0947C276.307 39.7691 275.165 33.4414 272.335 28.6768C269.489 23.8847 264.937 20.6866 258.312 20.6865H258.31Z",
    stroke: "#74453F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M365.5 1.5V122.5H338.878V25.8516H337.901L337.799 25.9004L315.061 36.71L310.574 16.3105L342.607 1.5H365.5Z",
    stroke: "#74453F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7226_7211",
    x1: 194,
    y1: 0,
    x2: 194,
    y2: 189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#382522"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#201D1C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiuxCard91);
export default __webpack_public_path__ + "static/media/uiux-card-91.bce5488e2684d8886b2f33963c8b47e7.svg";
export { ForwardRef as ReactComponent };